import { FC, useCallback, useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";

import { Icon } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import "./Breadcrumbs.scss";

import { useNavigateSearch } from "@/premium/hooks";

const PrettyNamesMap: { [key: string]: { name: string; params: string[] } } = {
  "": { name: "home", params: ["client"] },
  plan: { name: "planDetails", params: ["client", "enrollmentPlan"] },
  "medicare-prescription-payment-plan": { name: "mppp", params: ["client", "enrollmentPlan"] },
  "find-pharmacies": { name: "findPharmacies", params: ["client", "enrollmentPlan"] },
  pharmacies: { name: "results", params: ["client", "enrollmentPlan", "pharmacyName", "zipCode"] },
  "pharmacy-details": { name: "pharmacyDetails", params: ["client", "enrollmentPlan", "providerId"] },
};

const TRANSLATION_PATH = "BREADCRUMBS";

export const Breadcrumbs: FC = () => {
  const location = useLocation();
  const navigate = useNavigateSearch();
  const [pathParts, setPathParts] = useState<string[]>([]);
  const [searchParams, _] = useSearchParams();
  const { t: translate } = useTranslation();

  useEffect(() => {
    setPathParts(location.pathname.split("/"));
  }, [location.pathname]);

  const onPathPartClicked = useCallback(
    (pathPart: string) => {
      const destination = pathParts.slice(0, pathParts.indexOf(pathPart) + 1).join("/") || "/";
      const retainedPath = PrettyNamesMap[pathPart].params.reduce((accum, value) => {
        return { ...accum, [value]: searchParams.get(value) };
      }, {});
      navigate(destination, retainedPath);
    },
    [pathParts, navigate, searchParams],
  );

  return (
    <Shelf className="breadcrumbs-wrap-shelf" spacing="small">
      {pathParts.map((pathPart, idx) => {
        return (
          <div className="breadcrumbs-inner" key={pathPart + idx}>
            <Shelf spacing="small">
              {idx !== 0 && idx < pathParts.length && <Icon color="white" name="chevron-right" />}
              <p className="breadcrumbs-text" onClick={() => onPathPartClicked(pathPart)}>{translate(`${TRANSLATION_PATH}.${PrettyNamesMap[pathPart].name}`)}</p>
            </Shelf>
          </div>
        );
      })}
      <Shelf.Spacer />
    </Shelf>
  );
};
